<template>
	<div class="proposal-table px-3">
			<b-table-simple responsive bordered class="table-sm">
				<b-thead>
					<b-tr>
						<b-th class="align-middle text-center">No.</b-th>
						<b-th class="align-middle text-center" style="min-width: 100px;">Date/R&R</b-th>
						<b-th class="align-middle text-center" style="min-width: 60px;">Cap.</b-th>
						<b-th class="align-middle text-center" style="min-width: 180px;">Bank Name</b-th>
						<b-th class="align-middle text-center" style="min-width: 100px;">Facility</b-th>
						<b-th class="align-middle text-center" style="min-width: 50px;">Sts</b-th>
						<b-th class="align-middle text-center" style="min-width: 110px;">Limit</b-th>
						<b-th class="align-middle text-center" style="min-width: 110px;">Outstanding</b-th>
						<b-th class="align-middle text-center" style="min-width: 110px;">CCRIS<br> Instl.</b-th>
						<b-th class="align-middle text-center" style="min-width: 130px;">Merchant<br> Settlement.</b-th>
						<b-th class="align-middle text-center" style="min-width: 130px;">Invinity<br> Cr. Settlement.</b-th>
						<b-th class="align-middle text-center" style="min-width: 130px;">Other<br> Settlement.</b-th>
						<b-th class="align-middle text-center" style="min-width: 130px;">Final<br> Commitment.</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr v-for="(item, index) in tableData" :key="index" class="text-center">
						<b-td class="align-middle">{{ index + 1 }}</b-td>
						<b-td class="align-middle bg-grey">{{ item.pcom_approved_date }}</b-td>
						<b-td class="align-middle bg-grey">{{ item.pcom_capacity }}</b-td>
						<b-td class="align-middle input-cell">
							<el-select v-model="item.pcom_bank_id" placeholder="Select" :disabled="!is_editable" size="mini">
								<el-option v-for="bank in banks" :key="bank.bank_id" :label="bank.name" :value="bank.bank_id">
								</el-option>
							</el-select>
						</b-td>
						<b-td class="align-middle bg-grey">{{ item.pcom_loan_statue }}</b-td>
						<b-td class="align-middle bg-grey">{{ item.pcom_sts }}</b-td>
						<b-td class="align-middle bg-grey">{{ item.pcom_credit_limit | moneyFormatter }}</b-td>
						<b-td class="align-middle bg-grey">{{ item.pcom_current_outstanding | moneyFormatter }}</b-td>
						<b-td class="align-middle bg-grey">{{ item.pcom_current_installment | moneyFormatter }}</b-td>
						<b-td class="input-cell">
							<b-form-input type="text" v-model="item.pcom_merchant_solution" @keydown="_gHlp.checkNonNumericInput" size="mini"
								:disabled="!is_editable"></b-form-input>
						</b-td>
						<b-td class="input-cell">
							<b-form-input type="text" v-model="item.pcom_invinity_solution" @keydown="_gHlp.checkNonNumericInput" size="mini"
								:disabled="!is_editable"></b-form-input>
						</b-td>
						<b-td class="input-cell">
							<b-form-input type="text" v-model="item.pcom_other_solution" @keydown="_gHlp.checkNonNumericInput" size="mini"
								:disabled="!is_editable"></b-form-input>
						</b-td>
						<b-td class="input-cell">
							<b-form-input type="text" v-model="item.pcom_final_installment" @keydown="_gHlp.checkNonNumericInput" size="mini"
								:disabled="!is_editable"></b-form-input>
						</b-td>
					</b-tr>
				</b-tbody>
				<b-tfoot>
					<b-tr class="font-weight-600">
						<b-td colspan="6" class="text-right">
							<p class="font-weight-600">Total</p>
						</b-td>
						<b-td>{{ ccrisTotalLimit | moneyFormatter }}</b-td>
						<b-td>{{ ccrisTotalOutstanding | moneyFormatter }}</b-td>
						<b-td>{{ ccrisTotalInstallment | moneyFormatter }}</b-td>
						<b-td>{{ ccrisTotalMerchantSettlement | moneyFormatter }}</b-td>
						<b-td>{{ ccrisTotalInvinitySettlement | moneyFormatter }}</b-td>
						<b-td>{{ ccrisTotalOtherSettlement | moneyFormatter }}</b-td>
						<b-td>{{ ccrisTotalFinalCommitment | moneyFormatter }}</b-td>
					</b-tr>
				</b-tfoot>
			</b-table-simple>
		
		<div class="text-right" v-if="is_editable">
			<el-button class="bg-primary text-white py-2" @click="update" :loading="is_loading">Update</el-button>
		</div>
	</div>
</template>
<script>
import { Select, Option, Button } from 'element-ui'
import initialProposalEventBus from '@/assets/js/EventBus/initialProposalEventBus.js'
import { isEqual, cloneDeep } from 'lodash'
import { mapActions, mapState } from 'pinia'
import { useInvinityStore } from '@/stores/invinityStore'
import { useLookupStore } from '@/stores/lookupStore'
import { useInitialProposalStore } from '@/stores/initialProposalStore'

export default {
	props: ['psal_id','psal_invinity_id','is_editable'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		[Button.name]: Button,
	},
	data() {
		return {
			tableData: [],
			originalTableData: [],
			is_updated: false,
			is_loading: false,
		}
	},
	watch: {
		psal_id: {
			handler(newVal) {
				if(!_gHlp.isEmpty(newVal)){
					this.getListing(newVal)
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapState(useLookupStore, ['banks']),
		ccrisTotalLimit() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_credit_limit);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalOutstanding() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_current_outstanding);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalInstallment() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_current_installment);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalMerchantSettlement() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_merchant_solution);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalInvinitySettlement() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_invinity_solution);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalOtherSettlement() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_other_solution);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		},
		ccrisTotalFinalCommitment() {
			return this.tableData.reduce((acc, commitment) => {
				const amount = parseFloat(commitment.pcom_final_installment);
				if (isNaN(amount)) {
					return acc;
				}
				return acc + amount;
			}, 0);
		}
	},
	methods: {
		...mapActions(useInvinityStore, ['syncToLms']),
		...mapActions(useInitialProposalStore, ['updateProposalCommitment','getProposalCommitmentList']),
		getListing(psal_id){
			this.tableData = []
			this.originalTableData = []
			let params = {
				search:{
					pcom_psal_id: psal_id,
					pcom_kind: 'ccris'
				},
				paginate:'no_paginate'
			}
			this.getProposalCommitmentList(params).then(resp => {
				this.tableData = _gHlp.getValue(resp,'data',[]);
				this.originalTableData = cloneDeep(this.tableData);
			}).catch(e => {
				_gNotif.errorFunction(e)
			})
		},
		update() {
			var axiosCalls = []
			this.is_loading = true

			this.tableData.forEach((item) => {
				const original_item = this.originalTableData.find(o_item => o_item.pcom_id === item.pcom_id)
				if (!isEqual(original_item, item)) {
					axiosCalls.push(this.updateCcrisItem(item))
				}
			})

			Promise.all(axiosCalls)
				.then(res => {
					_gNotif.notifySuccess('<b>CCRIS Items </b> - Successfully Updated.')
					this.is_loading = false
					if (axiosCalls.length > 0) {
						initialProposalEventBus.$emit('refresh-proposal-detail')
						if(!_gHlp.isEmpty(this.psal_invinity_id)){
							this.syncToLms(this.psal_id)
						}
					}
				})
				.catch(e => {
					this.is_loading = false
					_gNotif.errorFunction(e)
				})
		},
		updateCcrisItem(item) {
			const bank = this.banks.find((bank) => bank.bank_id === item.pcom_bank_id)
			let data = {
				...item,
				"pcom_bank_name": bank ? bank.name : null,
				"pcom_bank_code": bank ? bank.code : null,
			}
			return this.updateProposalCommitment(data,item.pcom_id)
		}
	}
}
</script>